import BarChartIcon from '@mui/icons-material/BarChart'
import { Box, Typography } from '@mui/material'

import { ROUTES_PATH } from 'config'
import { color } from 'config/color'
import { Link } from 'react-router-dom'

export const NoResults = (): JSX.Element => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" p={10}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="50%"
        gap={1}
      >
        <BarChartIcon
          sx={{
            color: color.grey[500],
            backgroundColor: color.grey[100],
            fontSize: 50,
            borderRadius: '50%',
            padding: 3
          }}
        />
        <Typography color={color.grey[900]} fontWeight={500} fontSize={24}>
          No Results Found
        </Typography>

        <Typography textAlign="center" color={color.grey[700]} fontWeight={400} fontSize={16}>
          We couldn&apos;t find anything with the given date range. <br />If you think this is an
          error, please <Link to={ROUTES_PATH.CONTACT}>Contact Us</Link>.
        </Typography>
      </Box>
    </Box >
  )
}
